<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "您参与高空跳伞运动有多久？(年)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0skyDiveHowLongCN`,
					props: {
						suggest: {
							typeIncludes: `skyDiveHowLongCN`
						},
						createOptions: {
							type: `skyDiveHowLongCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "您是否高空跳伞组织的会员？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfSkyDiveClubCN`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfSkyDiveClubCN`
						},
						createOptions: {
							type: `isMemberOfSkyDiveClubCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0memberOfSkyDiveClubDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `memberOfSkyDiveClubDetailsCN`
						},
						createOptions: {
							type: `memberOfSkyDiveClubDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否军事跳伞协会的会员？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfMilitaryParachuteOrgCN`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfMilitaryParachuteOrgCN`
						},
						createOptions: {
							type: `isMemberOfMilitaryParachuteOrgCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0memberOfMilitaryParachuteOrgDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `memberOfMilitaryParachuteOrgDetailsCN`
						},
						createOptions: {
							type: `memberOfMilitaryParachuteOrgDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月的跳伞次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfSkyDiveJumpsLast12MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `numOfSkyDiveJumpsLast12MonthsCN`
						},
						createOptions: {
							type: `numOfSkyDiveJumpsLast12MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "过去 12 至 24 个月的跳伞次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfSkyDiveJumpsLast12to24MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `numOfSkyDiveJumpsLast12to24MonthsCN`
						},
						createOptions: {
							type: `numOfSkyDiveJumpsLast12to24MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "未来 12 个月的跳伞次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfSkyDiveJumpsNext12MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `numOfSkyDiveJumpsNext12MonthsCN`
						},
						createOptions: {
							type: `numOfSkyDiveJumpsNext12MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "经常的跳伞高度",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0skyDiveJumpAltitudeCN`,
					props: {
						suggest: {
							typeIncludes: `skyDiveJumpAltitudeCN`
						},
						createOptions: {
							type: `skyDiveJumpAltitudeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否参与高空跳伞的展览会或比赛？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isParticipateInSkyDiveExhibitionCN`,
					props: {
						suggest: {
							typeIncludes: `isParticipateInSkyDiveExhibitionCN`
						},
						createOptions: {
							type: `isParticipateInSkyDiveExhibitionCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0participateInSkyDiveExhibitionDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `participateInSkyDiveExhibitionDetailsCN`
						},
						createOptions: {
							type: `participateInSkyDiveExhibitionDetailsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "您是否藉高空跳伞活动收取酬劳？ ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isReceiveRemunerationForSkyDivingCN`,
					props: {
						suggest: {
							typeIncludes: `isReceiveRemunerationForSkyDivingCN`
						},
						createOptions: {
							type: `isReceiveRemunerationForSkyDivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0receiveRemunerationForSkyDivingDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `receiveRemunerationForSkyDivingDetailsCN`
						},
						createOptions: {
							type: `receiveRemunerationForSkyDivingDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
